export const getSlugByIndex = (pathname: string, index: number) => {
  const parts = pathname.split('/').filter((slug) => slug !== '')

  if (index < 0) {
    const item = parts[parts.length + index]
    return item
  }
  return parts[index]
}
